import { format, parse } from 'date-fns'

export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd'

export const formatDateForBackend = (date: Date) => format(date, BACKEND_DATE_FORMAT)

export const parseDateFromBackend = (date: string) => parse(date, BACKEND_DATE_FORMAT, new Date())
